import { FC } from 'react';

import { AcUnit } from '@mui/icons-material';
import { Tags } from 'src/ts/enums/tags.enums';

import ExtendedFreshTagIcon from '../ExtendedFresh';
import FreshTagIcon from '../Fresh';
import PantryTagIcon from '../Pantry';

/**
 *
 * Selects the correct icon to display based on the shelfLifeTagId (prev. frozen, fresh, extended fresh, pantry).
 * Also expects a color prop to set the color based on the tenant's theme.
 */
const ShelfLifeIcon: FC<{ shelfLifeTagId: number; color: string }> = ({
  shelfLifeTagId,
  color,
}) => {
  const h = 27.5;
  const w = 27.5;

  switch (shelfLifeTagId) {
    case Tags.PREVIOUSLY_FROZEN:
      return <AcUnit height={h} width={w} sx={{ color }} />;
    case Tags.FRESH:
      return <FreshTagIcon height={h} width={w} color={color} />;
    case Tags.EXTENDED_FRESH:
      return <ExtendedFreshTagIcon height={h} width={w} color={color} />;
    case Tags.PANTRY:
      return <PantryTagIcon height={h} width={w} color={color} />;
    default:
      return null;
  }
};

export default ShelfLifeIcon;
